import { Skeleton } from "@/components/ui/skeleton";

interface ChartSkeletonProps {
  height?: number;
  type?: "line" | "bar" | "pie";
}

export function ChartSkeleton({ height = 300, type = "line" }: ChartSkeletonProps) {
  if (type === "pie") {
    return (
      <div className="flex items-center justify-center" style={{ height }}>
        <Skeleton className="h-48 w-48 rounded-full" />
      </div>
    );
  }

  return (
    <div className="space-y-4" style={{ height }}>
      <div className="flex items-center justify-between">
        <Skeleton className="h-6 w-48" />
        <Skeleton className="h-8 w-32" />
      </div>
      <div className="flex items-end justify-between gap-2 h-full">
        {Array.from({ length: 7 }).map((_, i) => (
          <Skeleton
            key={`bar-${i}`}
            className="flex-1"
            style={{
              height: `${Math.random() * 60 + 20}%`,
            }}
          />
        ))}
      </div>
      <div className="flex justify-between">
        {Array.from({ length: 7 }).map((_, i) => (
          <Skeleton key={`label-${i}`} className="h-3 w-12" />
        ))}
      </div>
    </div>
  );
}
